// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"LogoutModal_modalContainer__2PhiD","closeButton":"LogoutModal_closeButton__3ravp","logoutText":"LogoutModal_logoutText__1YpDo"};